import { render } from "./FileViewDialog.vue?vue&type=template&id=10b04e77&scoped=true"
import script from "./FileViewDialog.vue?vue&type=script&lang=js"
export * from "./FileViewDialog.vue?vue&type=script&lang=js"

import "./FileViewDialog.vue?vue&type=style&index=0&id=10b04e77&scoped=true&lang=scss"

import exportComponent from "/tmp/b45e941b-d1ac-4235-8dba-072c0c886010/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b04e77"]])

export default __exports__